(function () {
  let chosen = '4';
  let chosenSet = false;
  let premiumOn = false;

  function getInput(sectionId) {
    return document.getElementById('Quantity-' + sectionId);
  }

  function apply(el) {
    const input = getInput(el.dataset.section);
    const want = premiumOn ? 'premium' : chosen;
    el.querySelectorAll('input[type="radio"]').forEach((r) => {
      r.checked = r.value === want;
    });
    if (!el.querySelector('input[type="radio"]:checked')) {
      premiumOn = false;
      chosen = '1';
      const first = el.querySelector('input[type="radio"]');
      if (first) first.checked = true;
    }
    document.documentElement.classList.toggle('qty-premium', premiumOn);
    if (!premiumOn && input && input.value !== chosen) {
      input.value = chosen;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const selectedLabel = el.querySelector('input[type="radio"]:checked')?.closest('.qty-bundle');
    if (selectedLabel) showPrice(selectedLabel);
  }

  function showGallery(el, label) {
    const id = label && label.dataset.media;
    const gallery = document.querySelector('media-gallery');
    if (!id || !gallery || typeof gallery.setActiveMedia !== 'function') return;
    gallery.setActiveMedia(el.dataset.section + '-' + id, false);
  }

  function showPrice(label) {
    const priceBox = document.querySelector('product-info .price');
    if (!priceBox || !label?.dataset.price) return;
    const saleNode = priceBox.querySelector('.price__sale .price-item--sale')
      || priceBox.querySelector('.price__regular .price-item--regular');
    const compareNode = priceBox.querySelector('.price__sale s.price-item--regular')
      || priceBox.querySelector('.price__sale .price-item--regular');
    if (saleNode) saleNode.textContent = label.dataset.price;
    if (compareNode && label.dataset.comparePrice) {
      compareNode.textContent = label.dataset.comparePrice;
    }
  }

  function interceptSubmit(el) {
    const form = document.getElementById('product-form-' + el.dataset.section);
    if (!form || form.dataset.premiumBound) return;
    form.dataset.premiumBound = '1';
    form.addEventListener('submit', async (event) => {
      if (!premiumOn) return;
      const tile = el.querySelector('.qty-bundle--premium');
      if (!tile) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('button[name="add"]');
      if (button) button.disabled = true;
      try {
        const r = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(tile.dataset.variantId), quantity: 1 }),
        });
        if (!r.ok) throw new Error(r.status);
        window.location.href = window.routes ? window.routes.cart_url : '/cart';
      } catch (err) {
        if (button) button.disabled = false;
      }
    }, true);
  }

  class QtyBundles extends HTMLElement {
    connectedCallback() {
      if (!chosenSet) {
        const requested = new URLSearchParams(window.location.search).get('pack');
        const requestedRadio = requested
          ? Array.from(this.querySelectorAll('input[type="radio"]')).find((radio) => radio.value === requested)
          : null;
        const def = requestedRadio?.closest('.qty-bundle') || this.querySelector('.qty-bundle[data-default]');
        if (def) chosen = def.dataset.qty;
        chosenSet = true;
      }
      apply(this);
      interceptSubmit(this);
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        const label = event.target.closest('.qty-bundle');
        if (event.target.value === 'premium') {
          premiumOn = true;
        } else {
          premiumOn = false;
          chosen = event.target.value;
        }
        apply(this);
        showPrice(label);
        showGallery(this, label);
      });
    }
  }
  if (!customElements.get('qty-bundles')) customElements.define('qty-bundles', QtyBundles);

  function reapplyAll() {
    document.querySelectorAll('qty-bundles').forEach(apply);
  }

  // Show the picture of the preselected package (the gallery starts on the first image).
  let galleryShown = false;
  function showDefaultGallery() {
    if (galleryShown) return;
    galleryShown = true;
    document.querySelectorAll('qty-bundles').forEach((el) => {
      const label = el.querySelector('input:checked') && el.querySelector('input:checked').closest('.qty-bundle');
      if (label) showGallery(el, label);
    });
  }

  // The default package is preselected: set the quantity once everything has initialised.
  function init() {
    reapplyAll();
    setTimeout(showDefaultGallery, 50);
  }
  if (document.readyState === 'complete') setTimeout(init, 0);
  else window.addEventListener('load', () => setTimeout(init, 0));

  // Dawn resets the quantity input when the variant changes; restore the chosen package afterwards.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(reapplyAll, 0);
      setTimeout(reapplyAll, 300);
    });
  }
})();
